import { AsyncStorage } from 'core';

let storage = {};

storage.get = async key => JSON.parse(await AsyncStorage.getItem(key));
storage.set = async (key, value) =>
  await AsyncStorage.setItem(key, JSON.stringify(value));
storage.clear = async () => await AsyncStorage.clear();

export default storage;



// WEBPACK FOOTER //
// ./src/utils/storage.js